// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"868":"bd7f9bc4e579ff58","915":"6634bf2d51adf123"}[chunkId] + ".js";
};